import AdministracionProductos from "components-base/pages/administracionproductos"
export const Productos = () =>{

    return(
        <div className="flex w-full flex-col gap-2"><AdministracionProductos /></div>
    )
}
export default Productos;